// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveDtaRequest
 */
export interface ApproveDtaRequest {
    /**
     * 
     * @type {string}
     * @memberof ApproveDtaRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveDtaRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveDtaRequest
     */
    version?: string;
}

/**
 * Check if a given object implements the ApproveDtaRequest interface.
 */
export function instanceOfApproveDtaRequest(value: object): value is ApproveDtaRequest {
    return true;
}

export function ApproveDtaRequestFromJSON(json: any): ApproveDtaRequest {
    return ApproveDtaRequestFromJSONTyped(json, false);
}

export function ApproveDtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveDtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function ApproveDtaRequestToJSON(json: any): ApproveDtaRequest {
    return ApproveDtaRequestToJSONTyped(json, false);
}

export function ApproveDtaRequestToJSONTyped(value?: ApproveDtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
        'reason': value['reason'],
        'version': value['version'],
    };
}
